var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feather Icons / edit",
    clipPath: "url(#clip0_687_57078)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.667 8.55167V11.6667C11.667 11.9761 11.5441 12.2728 11.3253 12.4916C11.1065 12.7104 10.8097 12.8333 10.5003 12.8333H2.33366C2.02424 12.8333 1.72749 12.7104 1.5087 12.4916C1.28991 12.2728 1.16699 11.9761 1.16699 11.6667V3.5C1.16699 3.19058 1.28991 2.89383 1.5087 2.67504C1.72749 2.45625 2.02424 2.33333 2.33366 2.33333H5.44866",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5003 1.16667L12.8337 3.5L7.00033 9.33333H4.66699V7L10.5003 1.16667Z",
    stroke: "#98A2B3",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_687_57078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e11099fd69ed382b46fe24c1f4f90da7.svg";
export { ForwardRef as ReactComponent };